import { obterStorage } from "./secureStorage";

export const getEmpresaIdLogada = () => {
  try {
    const dadosAuth = obterStorage("_da");
    return dadosAuth?.empresaDTO?.id || null;
  } catch (error) {
    console.error("Erro ao recuperar ID da empresa para o header", error);
    return null;
  }
};
